/* @flow */
import AskForBirthdate from './AskForBirthdate';
import AskForParentEmail from './AskForParentEmail';
import AskForRole from './AskForRole';
import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import * as React from 'react';
import TitleHeader from 'components/TitleHeader';
import User from 'entities/User';
import { Roles } from 'user/UserConstants';

class BirthdateModal extends React.Component<{ user: User }> {
  renderDoneCanChat() {
    return this.renderResponse(
      'Thanks!',
      <span>
        You’re now all set to use Remind. We’ve notified everyone that they can now send you
        messages.
      </span>
    );
  }

  renderDoneCannotChat() {
    return this.renderResponse(
      'Thanks!',
      <span>
        Two-way messaging is only available for students 13 and older. We’ve notified your teacher.
        Don’t worry—you will still receive announcements.
      </span>
    );
  }

  renderResponse(title: string, subtext: any) {
    return (
      <BoxBody>
        <TitleHeader title={title} subtext={subtext} flush />
      </BoxBody>
    );
  }

  renderPage() {
    const { user } = this.props;
    const role = user.getRole();
    if (!role) {
      return <AskForRole />;
    }
    if (role === Roles.student) {
      const birthdate = user.getBirthdate();
      if (!birthdate) {
        return <AskForBirthdate />;
      }
      const thirteenYearsAgo = new Date();
      thirteenYearsAgo.setFullYear(thirteenYearsAgo.getFullYear() - 13);
      if (birthdate > thirteenYearsAgo) {
        const parentEmail = user.getParentEmail();
        if (!parentEmail) {
          return <AskForParentEmail />;
        }
        return this.renderDoneCannotChat();
      }
    }
    return this.renderDoneCanChat();
  }

  render() {
    return (
      <Box {...this.props} className="BirthdateModal-box">
        {this.renderPage()}
      </Box>
    );
  }
}
export default BirthdateModal;
